import React, { useState, useEffect } from 'react';
import { getIngredients} from '../../api/axios';
import DataTable from '../Table/DataTable';
import { useTranslation } from 'react-i18next';
import { Box, Container } from '@mui/material';

const Ingredients = () => {
  const { t } = useTranslation('global');

  const [ingredients, setIngredients] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchIngredients = async() =>{
    const response = await getIngredients();
    console.log(response);
    setIngredients(response);
    
    setLoading(false);
  };

  useEffect(() => {
    fetchIngredients();
  }, []);

  const columns = [
    { Header: t("list.id"), accessor: 'id' },
    { Header: t("list.name"), accessor: 'name' },
    { Header: t("list.unit_of_measure_id"), accessor: 'unit_of_measure_id' },
    { Header: t("list.amount"), accessor: 'amount' },
    { Header: t("list.unit_price"), accessor: 'unit_price' }

  ];

  if (loading) {
    return <p>{t("list.loading")}</p>;
  }

  return (
    <Container sx={{ mt: 5 }} fullWidth>
      <DataTable initialData={ingredients} columns={columns} entityName="ingredients" h2={t("list.ingredients")} />
    </Container>
  );
};

export default Ingredients;
